import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

import messages from "../../../assets/locale/messages";
import { TabSetsLevels } from "../../../components/ui";
import AdminEmployeesManagement from "./AdminEmployeesManagement";
import AdminRolesManagement from "./AdminRolesManagement";
import {
  COMPANY_DETAILS_TEAM_TAB,
  TEAM_SUB_TABS,
  adminCompanyTeamRoutes,
} from "./adminCompanyTeamRoutes";

import "../../Company-portal/TeamsPermissions/TeamsPermissions.scss";

const AdminTeamPermissionsPanel = ({ companyId }) => {
  const history = useHistory();
  const location = useLocation();
  const copy = messages[useSelector((state) => state.locale.lang)].teamManagement;

  const subtabFromSearch = new URLSearchParams(location.search).get("subtab");
  const initialSubtab =
    subtabFromSearch === TEAM_SUB_TABS.roles
      ? TEAM_SUB_TABS.roles
      : TEAM_SUB_TABS.employees;
  const [activeSubtab, setActiveSubtab] = useState(initialSubtab);

  const tabs = useMemo(
    () => [
      { value: TEAM_SUB_TABS.employees, label: copy.tabs.employees },
      { value: TEAM_SUB_TABS.roles, label: copy.tabs.roles },
    ],
    [copy.tabs.employees, copy.tabs.roles],
  );

  useEffect(() => {
    const nextSubtab =
      subtabFromSearch === TEAM_SUB_TABS.roles
        ? TEAM_SUB_TABS.roles
        : TEAM_SUB_TABS.employees;
    setActiveSubtab(nextSubtab);
  }, [subtabFromSearch]);

  const handleSubtabChange = (nextSubtab) => {
    if (nextSubtab === activeSubtab) return;
    setActiveSubtab(nextSubtab);
    history.push(
      adminCompanyTeamRoutes.companyDetailsTabLocation(
        companyId,
        COMPANY_DETAILS_TEAM_TAB,
        nextSubtab,
      ),
    );
  };

  return (
    <div className="team-management team-management--embedded">
      <TabSetsLevels
        tabs={tabs}
        value={activeSubtab}
        onChange={handleSubtabChange}
        className="team-management__tabs"
      />

      {activeSubtab === TEAM_SUB_TABS.employees ? (
        <AdminEmployeesManagement companyId={companyId} />
      ) : (
        <AdminRolesManagement companyId={companyId} />
      )}
    </div>
  );
};

AdminTeamPermissionsPanel.propTypes = {
  companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default AdminTeamPermissionsPanel;
